import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import DienstleistungenFAQ from '../components/Dienstleistungen/DienstleistungenFAQ';
import DienstleistungenHeader from '../components/Dienstleistungen/DienstleistungenHeader';
import DienstleistungenAuflistung from '../components/Dienstleistungen/DienstleistungenAuflistung';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const Dienstleistungen = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('dienstleistungen_page_title')}
                description={t('dienstleistungen_page_description')}
                canonical={`${baseUrl}/dienstleistungen/`}
                openGraph={{
                    url: `${baseUrl}/dienstleistungen/`,
                    title: t('dienstleistungen_page_title'),
                    description: t('dienstleistungen_page_description'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('dienstleistungen_page_title'),
                            type: 'image/jpeg',
                        },
                        {
                            url: 'https://simplify-data.de/images/dienstleistungen-og.png',
                            width: 2000,
                            height: 1080,
                            alt: t('dienstleistungen_page_title'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('dienstleistungen_page_title'),
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('dienstleistungen_page_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: `https://simplify-data.de/dienstleistungen/`
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: `https://simplify-data.com/dienstleistungen/`
                    }
                ]}
            />
            <Navbar />
            <DienstleistungenHeader />
            <DienstleistungenAuflistung />
            <DienstleistungenFAQ />

            <Footer />
        </>
    );
}
export default Dienstleistungen;